

































































import ProductClickoutLinkView from "@/components/product-clickout-link.vue";
import { Component, Vue } from "@zoovu/runner-browser-api";
import { ProductRecommendationView } from "@zoovu/runner-web-design-base";
import { State } from "vuex-class";

@Component({
  name: "ProductRecommendationView",
  mixins: [ProductRecommendationView],
  components: {
    ProductClickoutLinkView
  }
})
export default class ProductRecommendationViewExtended extends Vue {
  public showProductProperties = false;

  public showComparisonButton = false;

  @State
  showProductPrice!: boolean;

  public get shouldRenderProperties(): boolean {
    return !!this.recommendation.properties.length && this.showProductProperties;
  }
}
